<template>
  <!-- 新增记录 -->
  <div class="score-card-add">
    <a-card class="card">
      <div class="text-right">
        <a-button @click="goBack">返回上一页</a-button>
      </div>
      <a-form layout="inline" :form="form">
        <a-form-item label="评分卡类型">
          <a-select
            style="width: 200px"
            v-decorator="$decorator('type', '请选择评分卡类型')"
            placeholder="请选择"
          >
            <a-select-option
              v-for="item in SCORE_CARD_SCHEMA"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="财报时间">
          <a-date-picker
            v-decorator="$decorator('year', '请选择财报时间')"
            mode="year"
            format="YYYY"
            placeholder="请选择"
            :open="isOpen"
            @openChange="handleOpenChange"
            @panelChange="handlePanelChange"
          />
        </a-form-item>
        <a-form-item>
          <a-button @click="search">查 询</a-button>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="_calculate">评 分</a-button>
        </a-form-item>
      </a-form>
    </a-card>

    <score-table
      :loading="loading"
      :flag="flag"
      :originalData="originalData"
      :scoreData="scoreData"
      :cardType="cardType"
    ></score-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ScoreTable from './components/ScoreTable.vue'
import { queryCalculateData, calculate, calculateCard, getRating } from './api'
import { SCORE_CARD_SCHEMA } from 'utils/staticData'
import { cloneDeep } from 'lodash'
import moment from 'moment'

export default {
  name: 'score-card-add',
  data() {
    return {
      SCORE_CARD_SCHEMA,
      form: this.$form.createForm(this),
      loading: false,
      flag: null,
      originalData: null,
      scoreData: null,
      isOpen: false,
      cardType: 1,
    }
  },
  computed: {
    ...mapGetters('app', ['company']),
  },
  mounted() {
    getRating().then(({ data }) => {
      var list = []
      data.forEach(item => {
        list.push({ value: item.id, label: item.cardName })
      })
      this.SCORE_CARD_SCHEMA = this.SCORE_CARD_SCHEMA.concat(list)
    })
  },
  methods: {
    async validate() {
      try {
        const values = await this.form.validateFields()
        const params = {
          year: moment(values.year).format('YYYY'),
          type: values.type,
          customerCode: this.company.code,
        }
        return Promise.resolve(params)
      } catch (error) {
        console.error('校验未通过')
        return false
      }
    },
    async search() {
      const check = await this.validate()
      if (!check) {
        return
      }
      if (this.loading) return
      try {
        this.loading = true
        const { data } = await queryCalculateData(check)
        const flag = data.flag
        this.flag = flag
        let originalData = cloneDeep(data)
        delete originalData.flag
        this.originalData = originalData
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    async _calculate() {
      const check = await this.validate()
      if (!check) {
        return
      }
      if (this.loading) return
      try {
        this.loading = true
        //type > 9 走自定义评分卡
        if (check.type > 9) {
          const { data } = await calculateCard(check)
          this.scoreData = data
          this.loading = false
          this.cardType = 2
        } else {
          // type <= 9 走固定的9种评分类型
          const { data } = await calculate(check)
          this.scoreData = data
          this.loading = false
        }
      } catch (error) {
        console.error(error)
      }
      this.loading = false
    },
    // changeCard(type) {
    //   if (type > 10) {
    //     this.cardType = 1
    //   }
    // },
    handleOpenChange(status) {
      this.isOpen = status
    },
    handlePanelChange(value) {
      this.form.setFieldsValue({ year: value })
      this.isOpen = false
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  components: {
    ScoreTable,
  },
}
</script>

<style></style>
